module.exports = __webpack_public_path__ + "static/media/medecine_generale_2.053e4ea6.jpg";